import React from "react";
import analytics from "web/script/analytics/analytics";
import { gettext } from "web/script/modules/django-i18n";
import userProfiler from "web/script/modules/userprofiler";
import AppDownloadBadge from "web/react/components/app-download-badge/app-download-badge";
import CloseButton from "web/react/components/buttons/close-button/close-button";
import mobileImage from "./images/lyst_app_mobile_screen.png";
import styles from "./app-download-banner-desktop.css";

interface AppDownloadBannerDesktopProps {
    isOpen: boolean;
    onClose(): void;
    eventLabel: string;
}

export default function AppDownloadBannerDesktop({
    isOpen,
    onClose,
    eventLabel,
}: AppDownloadBannerDesktopProps): JSX.Element | null {
    if (isOpen && !userProfiler.hasAppBannerShown()) {
        analytics.event("app_banner", "shown", eventLabel);
        userProfiler.saveAppBannerShown(true);
    }

    function dismissBanner(): void {
        analytics.event("app_banner", "dismissed", eventLabel);
        userProfiler.saveAppBannerDismissed();
        onClose();
    }

    if (isOpen) {
        return (
            <div className={styles.container}>
                <img src={mobileImage} className={styles.appImage} alt={"Lyst app"} />
                <div className={styles.titleContainer}>
                    <h1 className={styles.title}>
                        {gettext("app_download_desktop_banner.definitive_shopping.title")}
                    </h1>
                </div>
                <div className={styles.buttons}>
                    <AppDownloadBadge
                        color={"black"}
                        appDownloadLink={"desktopAppBannerFeeds"}
                        eventLabel={eventLabel}
                    />
                    <CloseButton className={styles.closeButton} onClick={dismissBanner} />
                </div>
            </div>
        );
    } else {
        return null;
    }
}
